import { useActivityTypesContext } from '../../../context'
import { useFetchActivityTypes } from './useFetchActivityTypes'

export function useData() {
  const requestState = useFetchActivityTypes()
  const [{ activityTypes, deleteDialogOpened }] = useActivityTypesContext()
  const isEmptyList = activityTypes.length === 0
  const loading = requestState === 'loading'

  return {
    activityTypes,
    isEmptyList,
    loading,
    deleteDialogOpened,
  }
}
